export default "__VITE_ASSET__D4nLnUH8__"